import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export function SignInPage() {
  const { authMode, signInWithPassword, signInDevOnly } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  if (authMode === null) {
    return <div className="screen screen--centered">Loading…</div>;
  }

  async function handleSupabaseSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await signInWithPassword(email, password);
      navigate('/jobs', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not sign in.');
    } finally {
      setSubmitting(false);
    }
  }

  async function handleDevSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await signInDevOnly(name);
      navigate('/jobs', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not sign in.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="screen screen--centered">
      <div className="signin-card">
        <img src="/icons/icon-192.svg" alt="" className="signin-logo" />
        <h1>PhotoLlama QR Cards</h1>
        <p className="signin-sub">Sign in to see your shoots</p>

        {authMode === 'supabase' ? (
          <form onSubmit={handleSupabaseSubmit} className="signin-form">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              autoFocus
              value={email}
              onChange={e => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
            {error && (
              <p className="form-error" role="alert">
                {error}
              </p>
            )}
            <button type="submit" className="btn btn--primary btn--large" disabled={submitting}>
              {submitting ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
        ) : (
          <>
            <form onSubmit={handleDevSubmit} className="signin-form">
              <label htmlFor="name">Your name</label>
              <input
                id="name"
                autoFocus
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder="e.g. George"
                autoComplete="name"
              />
              {error && (
                <p className="form-error" role="alert">
                  {error}
                </p>
              )}
              <button type="submit" className="btn btn--primary btn--large" disabled={submitting}>
                {submitting ? 'Signing in…' : 'Continue'}
              </button>
            </form>
            <p className="signin-note">
              Development sign-in only — no password is checked. Set up Supabase (see
              docs/DEPLOYMENT_HOSTINGER.md) for real accounts.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
